var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"teacherComments"},[_c('p',[_vm._v("教师评语:")]),_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"请输入内容"},model:{value:(_vm.resultEvaluate),callback:function ($$v) {_vm.resultEvaluate=$$v},expression:"resultEvaluate"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }